<template>
  <div id="api_configuration" class="flex flex-col h-full w-full text_color">
    <APIKeys />
  </div>
</template>

<script setup>
import APIKeys from "@/src/views/api_keys/APIKeys.vue";
</script>
